import React, { ReactElement } from 'react';

import styled from 'styled-components';
import { ClaimFlowType } from 'types';

import { GhostButton, StyledButton } from 'chime-ui/components/Button';
import { LightningBoltEmoji } from 'chime-ui/components/Icons';
import { Superscript, Text, Title } from 'chime-ui/components/Typography';
import { colors } from 'chime-ui/system/colors';

import LandingBase from 'components/SubPages/Landing/LandingBase';

import { useBonusAmount } from 'hooks/useBonusAmount';
import { useUserContext } from 'hooks/useUserContext';

import PayAnyoneValueProps from './PayAnyoneValueProps';
import usePayAnyoneLandingPage from './usePayAnyoneLandingPage';

function PayAnyoneLanding(): ReactElement {
  const [userData] = useUserContext();
  const { name, amount, claimWithChime: isClaimWithChimeEnabled } = userData;
  const {
    onCtaClickDebit,
    onCtaClickChime,
    navigateToEnrollment,
  } = usePayAnyoneLandingPage();
  const { bonusAmount } = useBonusAmount();

  return (
    <LandingBase
      pageLocation={'Pay Anyone Landing Page'}
      claimFlowType={ClaimFlowType.pay}
      landingTitle={
        <>
          <Title size={'large'}>{name}</Title>
          <Title size={'large'}>sent you ${amount}</Title>
        </>
      }
    >
      <TransferInfoLayout>
        <Text size={'small'} bold>
          <LightningBoltEmoji />
          {isClaimWithChimeEnabled ? 'Both are instant*' : 'Instant*'} +
          fee-free
        </Text>
      </TransferInfoLayout>
      <CTALayout>
        <PrimaryButton onClick={() => navigateToEnrollment(onCtaClickChime)}>
          Sign up - free + ${bonusAmount} bonus
          <Superscript>†</Superscript>
        </PrimaryButton>

        <TertiaryButton onClick={onCtaClickDebit}>
          <Text size={'standard'} color={colors.darkerGreen} bold>
            Claim without signing up
          </Text>
        </TertiaryButton>
      </CTALayout>
      <PayAnyoneValueProps />
    </LandingBase>
  );
}

const CTALayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  position: relative;
  bottom: 0;
`;

const TertiaryButton = styled(GhostButton)`
  height: 48px;
`;

const PrimaryButton = styled(StyledButton)`
  box-shadow: 0 4px 12px rgba(51, 51, 51, 0.16);
  position: relative;
  height: auto;
`;

const TransferInfoLayout = styled.div`
  text-align: center;
  margin-bottom: 0.5rem;
`;

export default PayAnyoneLanding;
